<template>
  <div></div>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as userService from "@/service/userService";
  import environment from "@/environment";

  @Component
  export default class Home extends BaseComponent {

    async mounted() {
      const user = userService.isSignedIn();

      if (user) {
        if (this.isCustomer() || this.isCustomerUser() || this.isViewUser()) {
          this.$router.replace("/meetings");
        } else if (this.isManager()) {
          this.$router.replace("/customers");
        } else if (this.isUserAdmin()) {
          this.$router.replace("/dashboard");
        }

      } else {
        // check sso login
        const searchParams = new URLSearchParams(location.search);
        const ticket = searchParams.get("ticket");
        const service = localStorage.getItem("vnptSsoService");
        let data = null;
        if (ticket && service) {
          try {
            data = await userService.signInVnptSso(service, ticket);
          } finally {
            // localStorage.removeItem("vnptSsoService");
            if(data && data.code == 'signinCas_userNotRegistered') {
              location.href = data.activateCodeUrl;
              return;
            }
            location.href = environment.appBaseUrl;
          }

        } else {
          this.$router.replace("/login");
        }

      }
    }

  }
</script>
